import { REQUIRED_PARTNER_FIELDS } from '../../../../utils/user/REQUIRED_FIELDS';
import usePartners from '../../Partners/_hooks/usePartners';

export default function useActivePartners(network, timestamp) {
  return usePartners(network, undefined, timestamp.end, {
    ...REQUIRED_PARTNER_FIELDS,
    inactive: false
  });
}
